import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import NotFound from '../views/404NotFound.vue'
import Admins from '../views/Admins.vue'
import Team from '../views/Team.vue'
import ManageMember from '../views/ManageMember.vue'
import RequestMember from '../views/RequestMembership.vue'
import RequesetUpdate from '../views/RequestUpdate.vue'
import ViewMemberSubscription from '../views/ViewMemberSubscription.vue'
import ManageEvent from '../views/ManangeEvents.vue'
import ManageNews from '../views/ManangeNews.vue'
import ManageOpportunity from '../views/ManangeOpportunity.vue'
import ManagePage from '../views/ManagePage.vue'
import AAACProfile from '../views/AAACProfile.vue'
import ManageSubscription from '../views/ManageSubscription.vue'
import ManagePayment from '../views/ManagePayment.vue'
import Notification from '../views/Notification.vue'
import Inbox from '../views/Inbox.vue'
import ManageCategory from '../views/ManageCategory.vue'
import store from '../store'
import ManageTitle from '../views/ManageTitle.vue'
import MemberCategory from '../views/MemberCategory.vue'
import MemberSector from '../views/MemberSector.vue'
import UserManual from '../views/UserManual.vue'

const routes = [
  {
    path: '/',
    alias: '/home',
    beforeEnter: projecteRoute,
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true, title: 'AAA-C Dashboard' }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    beforeEnter: projecteRoute,
    component: NotFound,
    meta: { requiresAuth: true, title: '404 Not Found' }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false, title: 'AAA-C - Login' }
  },
  {
    path: '/admin',
    name: 'Admin',
    beforeEnter: projecteRoute,
    component: Admins,
    meta: { requiresAuth: true, title: 'AAA-C - Admins' }
  },
  {
    path: '/team',
    name: 'Team',
    beforeEnter: projecteRoute,
    component: Team,
    meta: { requiresAuth: true, title: 'AAA-C - Team' }
  },
  {
    path: '/manage_member',
    name: 'ManageMember',
    beforeEnter: projecteRoute,
    component: ManageMember,
    meta: { requiresAuth: true, title: 'AAA-C - Manange Member' }
  },
  {
    path: '/request_member',
    name: 'RequestMember',
    beforeEnter: projecteRoute,
    component: RequestMember,
    meta: { requiresAuth: true, title: 'AAA-C - Request Member' }
  },
  {
    path: '/request_update',
    name: 'RequestUpdate',
    beforeEnter: projecteRoute,
    component: RequesetUpdate,
    meta: { requiresAuth: true, title: 'AAA-C - Request Update' }
  },
  {
    path: '/view_member_subscription/member_id=:id',
    name: 'ViewMemberSubscription',
    beforeEnter: projecteRoute,
    component: ViewMemberSubscription,
    meta: { requiresAuth: true, title: 'AAA-C - Member Subscription' }
  },
  {
    path: '/manage_event',
    name: 'ManageEvent',
    beforeEnter: projecteRoute,
    component: ManageEvent,
    meta: { requiresAuth: true, title: 'AAA-C - Events' }
  },
  {
    path: '/manage_news',
    name: 'ManageNews',
    beforeEnter: projecteRoute,
    component: ManageNews,
    meta: { requiresAuth: true, title: 'AAA-C - News' }
  },
  {
    path: '/manage_opportunity',
    name: 'ManageOpportunity',
    beforeEnter: projecteRoute,
    component: ManageOpportunity,
    meta: { requiresAuth: true, title: 'AAA-C - Opportunity' }
  },
  {
    path: '/manage_page',
    name: 'ManagePage',
    beforeEnter: projecteRoute,
    component: ManagePage,
    meta: { requiresAuth: true, title: 'AAA-C - Page' }
  },
  {
    path: '/profile',
    name: 'Profile',
    beforeEnter: projecteRoute,
    component: AAACProfile,
    meta: { requiresAuth: true, title: 'AAA-C - Page' }
  },
  {
    path: '/manage_subscription',
    name: 'ManageSubscription',
    beforeEnter: projecteRoute,
    component: ManageSubscription,
    meta: { requiresAuth: true, title: 'AAA-C - Subscriptions' }
  },
  {
    path: '/manage_payment',
    name: 'ManagePayment',
    beforeEnter: projecteRoute,
    component: ManagePayment,
    meta: { requiresAuth: true, title: 'AAA-C - Payments' }
  },
  {
    path: '/notification',
    name: 'Notification',
    beforeEnter: projecteRoute,
    component: Notification,
    meta: { requiresAuth: true, title: 'AAA-C - Notification' }
  },
  {
    path: '/inbox',
    name: 'Inbox',
    beforeEnter: projecteRoute,
    component: Inbox,
    meta: { requiresAuth: true, title: 'AAA-C - Inbox' }
  },
  {
    path: '/manage_category',
    name: 'MangeCategory',
    beforeEnter: projecteRoute,
    component: ManageCategory,
    meta: { requiresAuth: true, title: 'AAA-C - Category' }
  },
  {
    path: '/manage_board_title',
    name: 'MangeTitle',
    beforeEnter: projecteRoute,
    component: ManageTitle,
    meta: { requiresAuth: true, title: 'AAA-C - Manage Board Title' }
  },
  {
    path: '/member_category',
    name: 'MemberCategory',
    beforeEnter: projecteRoute,
    component: MemberCategory,
    meta: { requiresAuth: true, title: 'AAA-C - Member Category' }
  },
  {
    path: '/member_sector',
    name: 'MemberSector',
    beforeEnter: projecteRoute,
    component: MemberSector,
    meta: { requiresAuth: true, title: 'AAA-C - Working Sector' }
  },
  {
    path: '/user-manual',
    name: 'UserManual',
    beforeEnter: projecteRoute,
    component: UserManual,
    meta: { requiresAuth: true, title: 'AAA-C - User Manual' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

function projecteRoute(to, from, next) {
  var isAuthenticated = store.state.auth.status.loggedIn;
  if (isAuthenticated) {
    next()
  } else {
    next('/login')
  }
}

export default router
